<template>
    <div class="row">
        <div class="col-12">
            <catalogFilter @filter_change="filter_change" :col_units = "20"></catalogFilter>
            <div class="card-deck-wrapper"> 
                <div class="card-deck">
                    <div class="row no-gutters" v-if="filteredList.length > 0">   

                        <div  class="col-md-3 col-sm-6 col-lg-4 mb-sm-2"  v-for="item in filteredList" :key="item.id">
                            <cardWrapper>
                                <template v-slot:content> 
                                    <router-link  :to="{ path:'/model_view/'+item.id }"><img class="card-img-top img-fluid" :src="item.image"></router-link>
                                </template>
                                <h4 class="card-title"> 
                                    {{item.name}}
                                    <span v-if = models_exist.includes(item.id) class="badge badge-light-warning">({{models_exist.filter(unit => unit == item.id ).length}}) {{$t('message.already_in_list')}}</span>
                                    <div></div>
                                </h4>
                                <p class="card-text"><vuePerfectScrollbar class="scroll-area">{{item.anonce}}</VuePerfectScrollbar></p>
                                <small class="text-muted"><router-link class="btn btn-success float-right mb-2"  :to="{ path:'/model_view/'+item.id }">{{$t('message.details')}}...</router-link></small> 
                                <!--button class="add_button btn btn-success" @click="addDevice(item.id)">{{$t('message.select')}}</button-->
                            </cardWrapper> 
                        </div>

                    </div>
                    <div v-else class="col-12 text-center">
                        {{$t('message.devices_not_found')}}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <ul class="pagination justify-content-left">
                <li v-for="n in pages " @click="page = n" :class="[{active:page == n}]" class="page-item" :key = "n"><a class="page-link" href="#" >{{n}}</a></li>

            </ul>
        </div>
    </div>

</template>

<script>
import cardWrapper from '@/components/cardWrapper'; 
import catalogFilter from '@/components/catalog_filter'; 
import globalSettings from '@/config.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar/index.vue'
import axios from '@/axios'
export default {
  name: 'catalog',
    data () {
     return {
        models_list:[],
        page:1,
        pages:null,
        perpage:1,
        recomends:[],
        filter_obj:null,
        filterTags:[],
        filteredList:[],
     }
    },
    components:{
        cardWrapper,
        VuePerfectScrollbar,
        catalogFilter
    },
    computed: {
        models_exist: function () {
            let ar=[]
            this.$store.state.devices.forEach(function(item) {
                ar.push(item.model_id)
            });
            return  ar
        }
    },
    watch: {
            page: function () {  
                this.change(this.filter_obj)
            },
        },
    
    methods: {
            addDevice: function (id) { 
                this.$store.dispatch('add_device', id)
            },
           
           
           filter_change: function (filter) {
               this.change(filter)
               this.page = 1
           },
           
           change: function (filter) {
                
                
                this.filter_obj = filter
                this.perpage = filter.perpage    
                    let list  = this.models_list.filter(this.fil)
                    if(this.perpage !=='all'){
                        //построничный фильтр
                            let start_index = (this.page - 1) * this.perpage
                            let stop_index = start_index + this.perpage
                            this.pages = Math.trunc(list.length/this.perpage)
                            list = list.filter(function(value, index) {
                                if(index >= start_index && index < stop_index){
                                    return true    
                                }
                                return false
                            });
                        //построничный фильтр
                    }
                    this.filteredList = list
                
           },
           
           
           fil: function(model){
               let tags = [];
               if(this.filter_obj.recomend){
                   if(this.recomends.length > 0){
                       tags = this.recomends
                   }else{
                      return false 
                   }
                    
               }else{
                   if(this.filter_obj.tags.length>0){
                       tags = this.filter_obj.tags
                   }else{
                       return true
                   }
                     
               }
                let count=0
                let model_tags = model.search_tags.split(',')
                for (let i = 0; i < model_tags.length; i++) {
                    if(tags.includes(model_tags[i])){
                        count++
                        //return true
                       
                    }       
                }
                if(count >= tags.length){
                    return true
                }else{
                   return false 
                }
           },
           
           
            
   
            getDevices: function () {
            let data={
                lang : this.$i18n.locale
            }
            axios.post(globalSettings.api_url + 'device-models',data)
            .then(response => {
                this.models_list = response.data
                axios.get(globalSettings.api_url + 'user/tags')
                .then(response => {
                    this.recomends=response.data
                    this.filter_change(this.filter_obj)
                })
            })
            .catch(error => {
               console.log(error)
            })
            
        }
    },
        
    beforeMount() {
        this.getDevices()
        
    
    },
  
  
}
</script>
<style>
    .scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 150px;
}
.add_button{
    position: absolute;
    top:0;
    right: 0;
    border-radius: 0 0 0 4px
}

</style>

